import { ProductType } from '@/types';

export const isOneSizeProductType = (productType: ProductType) => {
  return productType.sizes.length === 1;
};
